import type { Database } from "@/integrations/supabase/types";

type EncounterSpecialty = Database["public"]["Enums"]["encounter_speciality_type"];

export const isGoldenDatasetSupported = (specialty: EncounterSpecialty | undefined) => specialty !== "infusion";
